<div class="fixed-top d-flex flex-column">
	<div class="header-zone d-flex justify-content-center">
		<div>
			<!-- <header>
				<div class="d-flex justify-content-between m-header align-items-center">
					<a href="javascript:void(0);" (click)="restartClick()" class="m-undo" [ngClass]="{'invisible': false}">
						<i class="fa fa-undo" aria-hidden="true"></i>
						<span>{{"COMMON.UNDO" | translate}}</span>
					</a>
					<img src="assets/images/logo.png" class="m-logo" alt="{{'COMMON.LOGO_ALT' | translate}}" />
					<button class="btn btn-link p-0" (click)="openHelpDialog()">{{'START.CHAT'| translate}}</button>
				</div>
			</header> -->
			<app-header></app-header>
			<!-- <a href="javascript:void(0)" class="" (click)="sendFormTest()">sendFormTest</a> -->
			<div class="d-none d-md-flex flex-row mt-2 row align-items-center">
				<app-step-indicator class="col-12"></app-step-indicator>
				<!-- <app-estimated-finish-time class="col text-left"></app-estimated-finish-time> -->
			</div>
			
			<div class="d-flex d-md-none flex-sm-row flex-column px-2 justify-content-between" style="background-color:white">
				<app-step-indicator></app-step-indicator>
				<!-- <app-estimated-finish-time class="d-flex justify-content-end align-items-center py-md-2"></app-estimated-finish-time> -->
			</div>
		</div>
	</div>
	<div  [ngClass]="{'invisible':!showScrollHint}" class="scroll-hint d-flex justify-content-center"><i class="fa fa-chevron-up fa-2x " aria-hidden="true"></i></div>
</div>

	
	<div class="content-zone" [ngClass]="{'q-focus':showScrollHint}" >
		<router-outlet></router-outlet>
	</div>


// WEBPACK FOOTER //
// ./src/app/mashkanta-questioner/mashkanta-questioner.component.html